import { render } from "./BrandOperatorAdmin.vue?vue&type=template&id=44066588"
import script from "./BrandOperatorAdmin.vue?vue&type=script&lang=js"
export * from "./BrandOperatorAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__